export { default } from './CommonTabs'
export type { CommonTab } from './CommonTabs'
